import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "main",
      component: () => import("./views/HomeView.vue")
    },
    {
      path: "/story",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/StoryView.vue"),
      children: [
        {
          path: "",
          name: "Introduction",
          component: () => import("./views/Story/StoryZeroView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "main") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "end",
          name: "End",
          component: () => import("./views/Story/StoryEndView.vue")
        },
        {
          path: "error",
          name: "ERROR",
          component: () => import("./views/Story/PageNotFound.vue")
        },
        {
          path: "one",
          name: "One",
          component: () => import("./views/Story/StoryOneView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Introduction") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "two",
          name: "Two",
          component: () => import("./views/Story/StoryTwoView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "One") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "three",
          name: "Three",
          component: () => import("./views/Story/StoryThreeView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Two") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "four",
          name: "Four",
          component: () => import("./views/Story/StoryFourView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Two" || from.name == "Three") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "five",
          name: "Five",
          component: () => import("./views/Story/StoryFiveView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Four") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "six",
          name: "Six",
          component: () => import("./views/Story/StorySixView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Five") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "seven",
          name: "Seven",
          component: () => import("./views/Story/StorySevenView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Six") {
              next();
            } else {
              next("/story/error");
            }
          }
        },
        {
          path: "eight",
          name: "Eight",
          component: () => import("./views/Story/StoryEightView.vue"),
          beforeEnter: (to, from, next) => {
            if (from.name == "Seven") {
              next();
            } else {
              next("/story/error");
            }
          }
        }
      ]
    }
  ]
});
